import { FC } from 'react'

const ListIcon: FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icon/list">
      <rect
        id="Rectangle 3"
        x="6.25"
        y="1.25"
        width="13.75"
        height="1.25"
        rx="0.5"
        fill="#575757"
      />
      <rect
        id="Rectangle 3 Copy"
        x="6.25"
        y="8.75"
        width="13.75"
        height="1.25"
        rx="0.5"
        fill="#575757"
      />
      <rect
        id="Rectangle 3 Copy 2"
        x="6.25"
        y="16.25"
        width="13.75"
        height="1.25"
        rx="0.5"
        fill="#575757"
      />
      <path
        id="Oval 6 Copy"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1.875C0 2.91053 0.839466 3.75 1.875 3.75C2.91053 3.75 3.75 2.91053 3.75 1.875C3.75 0.839466 2.91053 0 1.875 0C0.839466 0 0 0.839466 0 1.875ZM1.25 1.875C1.25 2.22018 1.52982 2.5 1.875 2.5C2.22018 2.5 2.5 2.22018 2.5 1.875C2.5 1.52982 2.22018 1.25 1.875 1.25C1.52982 1.25 1.25 1.52982 1.25 1.875Z"
        fill="#575757"
      />
      <path
        id="Oval 6 Copy 3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9.375C0 10.4105 0.839466 11.25 1.875 11.25C2.91053 11.25 3.75 10.4105 3.75 9.375C3.75 8.33947 2.91053 7.5 1.875 7.5C0.839466 7.5 0 8.33947 0 9.375ZM1.25 9.375C1.25 9.72018 1.52982 10 1.875 10C2.22018 10 2.5 9.72018 2.5 9.375C2.5 9.02982 2.22018 8.75 1.875 8.75C1.52982 8.75 1.25 9.02982 1.25 9.375Z"
        fill="#575757"
      />
      <path
        id="Oval 6 Copy 4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 16.875C0 17.9105 0.839466 18.75 1.875 18.75C2.91053 18.75 3.75 17.9105 3.75 16.875C3.75 15.8395 2.91053 15 1.875 15C0.839466 15 0 15.8395 0 16.875ZM1.25 16.875C1.25 17.2202 1.52982 17.5 1.875 17.5C2.22018 17.5 2.5 17.2202 2.5 16.875C2.5 16.5298 2.22018 16.25 1.875 16.25C1.52982 16.25 1.25 16.5298 1.25 16.875Z"
        fill="#575757"
      />
    </g>
  </svg>
)

export default ListIcon
